// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"Checkbox_checkbox__Vi_Rk","focus_target":"Checkbox_focus_target__7LPTO"};